import { render } from "./Dialog_Company.vue?vue&type=template&id=2566c870"
import script from "./Dialog_Company.vue?vue&type=script&lang=js"
export * from "./Dialog_Company.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__